import { render, staticRenderFns } from "./FloatingContactButtons.vue?vue&type=template&id=795fe626&scoped=true"
import script from "./FloatingContactButtons.vue?vue&type=script&lang=js"
export * from "./FloatingContactButtons.vue?vue&type=script&lang=js"
import style0 from "./FloatingContactButtons.vue?vue&type=style&index=0&id=795fe626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795fe626",
  null
  
)

export default component.exports